import { c as _c } from "react/compiler-runtime";
import { IcoRotate16 } from '@onefootprint/icons';
import type { DocumentUpload } from '@onefootprint/request-types/dashboard';
import { IconButton } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import useDocumentUploadSideText from '@/entity/hooks/use-document-upload-side-text';
export type UploadTitleCardProps = {
  upload: DocumentUpload & {
    isLatest: boolean;
  };
  customTimestamp?: string;
  rightChildren?: React.ReactNode;
  onRotate?: () => void;
};
const UploadTitleCard = t0 => {
  const $ = _c(32);
  const {
    upload: t1,
    customTimestamp,
    rightChildren,
    onRotate
  } = t0;
  const {
    timestamp,
    failureReasons,
    isLatest,
    side,
    identifier,
    version
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "fieldset.documents.details"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  const sideT = useDocumentUploadSideText();
  const isSuccess = !failureReasons || failureReasons.length === 0;
  const t3 = `upload-title-${identifier}:${version}`;
  let t4;
  if ($[1] !== isSuccess) {
    t4 = cx("text-label-2 truncate flex gap-1 items-center w-full", {
      "text-success": isSuccess
    }, {
      "text-error": !isSuccess
    });
    $[1] = isSuccess;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== isSuccess || $[4] !== t) {
    t5 = isSuccess ? t(_temp) : t(_temp2);
    $[3] = isSuccess;
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isLatest || $[7] !== side || $[8] !== sideT || $[9] !== t) {
    t6 = isLatest && <span className="text-label-2">{t(_temp3, {
        side: sideT(side)
      })}</span>;
    $[6] = isLatest;
    $[7] = side;
    $[8] = sideT;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-label-2">⋅</span>;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== customTimestamp || $[17] !== timestamp) {
    t9 = customTimestamp ?? format(new Date(timestamp), "MM/dd/yy h:mma");
    $[16] = customTimestamp;
    $[17] = timestamp;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <div className="shrink-0 text-snippet-1 text-tertiary">{t9}</div>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== onRotate || $[22] !== t) {
    t11 = onRotate && <><span className="text-label-2">⋅</span><IconButton aria-label={t(_temp4)} icon={IcoRotate16} onClick={onRotate} variant="ghost" size="tiny" className="-my-0.5" /></>;
    $[21] = onRotate;
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t7) {
    t12 = <div className="flex flex-wrap md:flex-nowrap items-center gap-x-2 gap-y-1 md:gap-2">{t7}{t8}{t10}{t11}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t7;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== rightChildren || $[29] !== t12 || $[30] !== t3) {
    t13 = <div className="flex flex-wrap md:flex-nowrap items-center justify-between w-full max-w-full gap-1 px-3 py-2 border border-solid rounded border-tertiary bg-primary z-drawer" aria-label={t3}>{t12}{rightChildren}</div>;
    $[28] = rightChildren;
    $[29] = t12;
    $[30] = t3;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};
export default UploadTitleCard;
function _temp($) {
  return $.status.success;
}
function _temp2($_0) {
  return $_0.status.failed;
}
function _temp3($_1) {
  return $_1.titleCard.latest;
}
function _temp4($_2) {
  return $_2.titleCard.rotate;
}